// ============================================
// Detail Module - Menu (ES6)
// 상세 메뉴 기능
// ============================================

import { getSelectedContent } from './state.js';
import { closeContentDetailModal } from './modal.js';
import { getCurrentUser } from '../../app/state.js';
import { showToast } from '../../utils.js';

// ============================================
// 상세 메뉴 함수
// ============================================

export function showDetailMenu() {
  const modal = document.getElementById('detailMenuModal');
  const sheet = modal.querySelector('.detail-menu-sheet');

  const selectedContent = getSelectedContent();
  const user = getCurrentUser();

  // 내 작품인지 확인
  const isMyCreation = selectedContent?.isMyCreation ||
    (user && selectedContent?.creatorId === user.uid) ||
    (user && selectedContent?.authorId === user.uid);

  if (isMyCreation) {
    // 내 작품: 편집, 공유 메뉴만 표시
    sheet.innerHTML = `
      <div class="detail-menu-item" data-action="edit">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        <span>점술가 편집</span>
      </div>
      <div class="detail-menu-item" data-action="share">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
        </svg>
        <span>공유하기</span>
      </div>
      <div class="detail-menu-cancel" data-action="cancel">취소</div>
    `;
  } else {
    // 다른 사람 작품: 공유, 신고, 차단 메뉴
    sheet.innerHTML = `
      <div class="detail-menu-item" data-action="share">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
          <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
        </svg>
        <span>공유하기</span>
      </div>
      <div class="detail-menu-item" data-action="report">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/>
        </svg>
        <span>신고하기</span>
      </div>
      <div class="detail-menu-item danger" data-action="block">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
        </svg>
        <span>차단하기</span>
      </div>
      <div class="detail-menu-cancel" data-action="cancel">취소</div>
    `;
  }

  modal.style.display = 'flex';
  // ModalManager에 push (뒤로가기 대응)
  if (window.ModalManager) {
    window.ModalManager.push('detailMenuModal');
  }
}

export function closeDetailMenu(event) {
  if (event && event.target !== event.currentTarget) return;
  document.getElementById('detailMenuModal').style.display = 'none';
  // ModalManager에서 제거
  if (window.ModalManager) {
    window.ModalManager.remove('detailMenuModal', true);
  }
}

export function editMyCreation() {
  closeDetailMenu();
  const selectedContent = getSelectedContent();
  const contentId = selectedContent?.id;
  closeContentDetailModal();
  if (contentId && typeof CreatorModule !== 'undefined') {
    // 내 작품 탭으로 이동하고 편집 모달 열기
    window.switchTab?.('myWorks');
    setTimeout(() => {
      CreatorModule.openEditor(contentId);
    }, 100);
  }
}

export function shareContent() {
  closeDetailMenu();
  const selectedContent = getSelectedContent();
  if (navigator.share && selectedContent) {
    navigator.share({
      title: selectedContent.title,
      text: selectedContent.shortDesc || selectedContent.description,
      url: window.location.href
    }).catch(e => {
      // 사용자 취소 (AbortError)는 무시
      if (e.name !== 'AbortError') {
        console.error('[DetailMenu] 공유 실패:', e);
      }
    });
  } else {
    showToast('공유 기능을 사용할 수 없습니다');
  }
}

export function reportContent() {
  closeDetailMenu();
  showToast('신고가 접수되었습니다');
}

export function blockCreator() {
  closeDetailMenu();
  showToast('해당 크리에이터가 차단되었습니다');
}
